import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AddCircle, Info, NewReleases, ReportProblem } from "@mui/icons-material";
import { ActionsButtons } from "../../components/CustomButtons/ActionsButtons";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { IssueForm } from "../Issues/IssueForm";
import { CustomerOrderFormModal } from "./orders/CustomerOrderFormModal";
import { useRuleValidator } from "../../hooks/useRuleValidator";
import { useSearch } from "../../hooks/useSearch";
import { useToggle } from "../../hooks/useToggle";
import { PERMISSIONS } from "../../router/permissions";
import {
  getCreditAccount,
  getCustomerProducts,
  getSchedules,
  selectCustomer,
  selectCustomerAccount,
  setCallID
} from "../../redux/actions/customers/customersAction";
import { CUSTOMERS_TYPES } from "../../redux/reducers/customers/customersTypes";
import { SET_SUGGESTED_UNITS } from "../../redux/reducers/units_v2/unitsReducer";

const ActionsCell = ({ original }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { clearSnackbar, startRequestComp, stopRequestComp } = useSearch();
  const { stationsList } = useSelector(({ companies }) => companies);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { customers, amazonConnectCall } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const [openIssueForm, setOpenIssueForm] = useToggle();
  const [
    openOrderForm,
    setOpenOrderForm,
    setOpenOrderFormValue,
  ] = useToggle();
  const [modalKey, setModalKey] = useState(0);
  const customer = customers.find(
    (customer) => customer.id === original.idCustomer
  );
  const canGenerateOrder = useRuleValidator(PERMISSIONS.CUSTOMER_SERVICES);
  const validate =
    customer?.code?.includes("ERP") &&
    !Object.hasOwn(original, "creditAccounts");

  const navigate = useCallback(() => {
    history.push(
      `/admin/cliente/${customer?.id}/${original.id}/${original?.code}/${
        original?.localPhone ? original.localPhone : original?.phone
      }/${original?.fullAddress ? original.fullAddress : ""}`
    );
  }, [original, customer?.id]);

  const handleNav = async () => {
    clearSnackbar();
    startRequestComp("loadingCustomerNavigation");
    await dispatch(selectCustomer(customer));
    await dispatch(selectCustomerAccount(original, 1));
    dispatch({
      type: CUSTOMERS_TYPES.NEW_CUSTOMER_MODE,
      payload: false,
    });
    validate && (await dispatch(getCreditAccount(original.id, false)));
    stopRequestComp("loadingCustomerNavigation");
    await navigate();
  };

  const handleOpen = async () => {
    startRequestComp("loadingCustomerNavigation");
    // Clear any existing suggestions
    dispatch({ type: SET_SUGGESTED_UNITS, payload: {} });
    validate && (await dispatch(getCreditAccount(original.id, true)));
    await dispatch(setCallID(amazonConnectCall?.callID));
    await dispatch(getSchedules(original?.idStation));
    await dispatch(
      getCustomerProducts(original?.id, {
        stations: stationsList,
        customerIdStation: original?.idStation,
      })
    );
    setModalKey(Date.now());
    await setOpenOrderForm();
    stopRequestComp("loadingCustomerNavigation");
  };

  const buttons = [
    {
      Icon: AddCircle,
      color: customer?.isCreditSuspended ? 3 : 1,
      validation: canGenerateOrder,
      onClick: handleOpen,
      loading: isLoadingComp?.loadingCustomerNavigation,
      tooltip: "Generar pedido"
    },
    {
      Icon: original?.isNew ? NewReleases : Info,
      color: original?.isNew ? 1 : 0,
      onClick: handleNav,
      loading: isLoadingComp?.loadingCustomerNavigation,
      tooltip: "General"
    },
    {
      Icon: ReportProblem,
      color: 4,
      onClick: setOpenIssueForm,
      loading: isLoadingComp?.loadingCustomerNavigation,
      tooltip: "Generar ticket de fuga o queja"
    }
  ];

  return (
    <>
      <ActionsButtons buttons={buttons} />

      <ModalV2
        open={openOrderForm}
        onClose={() => setOpenOrderFormValue(false)}
        title="Generar pedido"
        toRight
      >
        <CustomerOrderFormModal
          key={modalKey}
          account={original}
          onClose={() => setOpenOrderFormValue(false)}
        />
      </ModalV2>
      <ModalV2
        open={openIssueForm}
        onClose={setOpenIssueForm}
        title="Crear ticket"
        toRight
      >
        <IssueForm
          onClose={setOpenIssueForm}
          isNew
          account={{
            ...original,
            idAccount: original.id,
            id: null,
            status: "ACTIVE",
          }}
        />
      </ModalV2>
    </>
  );
};

export default ActionsCell;